import user from '@/stores/user'
import records from '@/stores/records'
import products from '@/stores/products'
import bookings from '@/stores/bookings'
import payments from '@/stores/payments'
import subscriptions from '@/stores/subscriptions'
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    products,
    bookings,
    payments,
    records,
    subscriptions
  }
})
export default store
